
// import { nanoid } from 'nanoid'
import React from 'react'
// import { setObject } from '../../utils/useful'
// import FormViewer from '../FormViewer'
// import { apisObject } from '../../variables/FetchInputApis'
// import SelectInput from './SelectInput'
// import HttpServices from '../../utils/Http.services'
import { checkTranslation, checkVariablesListForValue, translate } from '../../utils/useful'
// import ParamsInput from './ParamsInput'
import TextInput from './TextInput'
import FixedView from '../FixedView'
import ParamsStageList from './ParamsStageList'


class TextInputWithParams extends React.Component {

    state = {
        params: [
            // { name: 'category', },
            // { name: 'provider', }
        ],

        fullParams: {}
    }


    componentDidMount() {

        this.init()
        this.setFullParams()


    }

    componentDidUpdate(prevProps) {
        if (prevProps.header?.information?.frame !== this.props.header?.information?.frame) {
            this.init()
        }

        if (this.props.params != prevProps.params) {
            this.setFullParams()
        }
    }



    setFullParams = () => {


        let fullParams = {}

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                fullParams[param.value] = { key: param.key ?? param.value, label: param.label, list: param.fields ?? param.list, info: param.info }
            }
        } else {
            fullParams = this.props.params
        }

        // console.log(fullParams)
        this.setState({ fullParams })
    }


    init() {

        // console.log('init',this.props.header?.information)


        this.setState({ showFixedView: false }, () => {
            setTimeout(() => {
                this.setState({ showFixedView: true })
            }, 10);
        })


    }


    changeValue = (key, value, extra) => {

        this.props.changeValue(this.props.header?.key, value, this.props.extra)

        if (this[`fixedView`]) {
            this[`fixedView`]?.hideView()
        }
    }





    render() {

        // console.log(this.props.params)
        let data = this.props.data
        if (data && /\{\{(.*?)\}\}/.test(data)) {
            let baseData = data.replace(/{/g, '').replace(/}/g, '')

            data = checkVariablesListForValue(this.state.fullParams, baseData)?.label
            // console.log(value)
            if (data) {
                data = '{{' + data + '}}'
            }
        }


        return (
            <div className='flexcb h-100 w-100'>


                <TextInput data={data} header={{ key: this.props.header?.key, information: {} }} extra={this.props.extra} params={this.state.fullParams} changeValue={this.changeValue} />

                <div className="flexcc">

                    <button ref={el => this[`target`] = el} className=" font-size-12 mld-2 white br-20 text-semibold flexcc" style={{ backgroundColor: '#ddd', padding: 5, }} onClick={() => this[`fixedView`]?.showView()}>
                        <img className="  " src="/assets/icons/useful/brackets-curly.svg" alt="" height={12} />
                    </button>


                    {this.state.showFixedView && (
                        <FixedView zIndex={10} ref={el => this[`fixedView`] = el} nodeRef={this[`target`]} xOffset={-12} bottomOffset={27} topOffset={5} width={180} maxWidth={180} >

                            <div className='bg-white br-10 p-2 shadow-3  w-100' style={{}}>

                                {/* {this.paramsListView(this.props.fullParams, this.state.tempCurrentSourceObject, 'targetSelectHandler')} */}
                                <ParamsStageList params={this.state.fullParams} header={{ key: this.props.header?.key }} data={this.props.data} changeValue={this.changeValue} extra={this.props.extra} asVariable={true} variables={this.props.variables} />

                            </div>
                        </FixedView>
                    )}
                </div>

            </div>
        );
    }
}

export default TextInputWithParams;